/*
* Salla Tabs Component: has many sizes, styles and loading state.
* You can use these classes to target the elements in the component.
*/

.s-tabs {
  &-selected {}

  &-bg-normal {}

  &-header {
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }
  &-default-background {}

  &-content {}

  &-content-selected {}

  &-transit {}
}
